<template>
    <div>
        <button class="btn btn-primary" type="button" @click="showModal">
            <i class="fas fa-info-circle"></i> Richiedi informazioni
        </button>
    </div>
</template>

<script>
    import Modal from '../../classes/modal.class';

    export default {
        props: ['cantiere', 'name', 'source'],
        methods: {
            showModal() {
                const modal = new Modal({
                    name: this.name,
                    class: 'small-modal',
                    padding: false,
                    component: 'contatta-inserzionista-cantiere',
                    closeButton: true,
                    callback: () => { this.$modal.hide(this.name); },
                    bind: {
                        cantiere: this.cantiere,
                        source: this.source
                    }
                });
                this.$root.pushModal(modal);
            }
        },
    }
</script>
